import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../components/layout/Layout'; // Layout padrão que utilizamos
import Button from '../../components/common/Button'; // Botão genérico

const ConvenioPage = () => {
  const { convenioName } = useParams(); // Pega o nome do convênio da URL

  // Dados fictícios para o exemplo
  const convenioData = {
    unimed: {
      name: 'Unimed',
      description: 'Plano de saúde com ampla cobertura em todo o Brasil.',
      contact: '0800 123 456',
    },
    amil: {
      name: 'Amil',
      description: 'Plano de saúde com serviços hospitalares e ambulatoriais.',
      contact: '0800 654 321',
    },
    // ... outros convênios
  };

  const convenio = convenioData[convenioName.toLowerCase()] || {
    name: 'Convênio não encontrado',
    description: '',
    contact: '',
  };

  return (
    <Layout>
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">{convenio.name}</h1>
        <p className="text-gray-600 mb-4">{convenio.description}</p>
        <p className="text-gray-600 mb-4">
          <strong>Contato:</strong> {convenio.contact}
        </p>

        <div className="flex space-x-4 mb-6">
          <Button
            type="detalhes"
            label="Voltar para Convênios"
            onClick={() => window.history.back()}
          />
          <Link to={`/convenios/${convenioName}/detalhes`}>
            <Button
              type="detalhes"
              label="Ver Detalhes"
              className="bg-secondary"
            />
          </Link>
        </div>

        {/* Seções dinâmicas do convênio */}
        <section>
          <h2 className="text-lg font-semibold mt-6">
            Cobertura e Autorizações
          </h2>
          <p>
            Exemplo de dados sobre a cobertura e autorizações específicas deste
            convênio.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mt-6">
            Solicitações de Procedimentos
          </h2>
          <p>Formulários ou dados de procedimentos deste convênio.</p>
        </section>
      </div>
    </Layout>
  );
};

export default ConvenioPage;
